"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SeriesSchema = exports.SeriesValueSchema = void 0;
const zod_1 = require("zod");
exports.SeriesValueSchema = zod_1.z.number().nullable();
exports.SeriesSchema = zod_1.z.object({
    key: zod_1.z.string(),
    label: zod_1.z.string(),
    values: zod_1.z.array(exports.SeriesValueSchema),
    axis: zod_1.z.string().nullable(),
    stack: zod_1.z.string().nullable(),
    mode: zod_1.z.string().nullable(),
});
//# sourceMappingURL=seriesSchema.js.map